/** Browser fallback when Edge Function is unavailable — website meta only. */

import { websiteHost } from './webIntelMatch';

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export async function buildPublicIntelHtml(
  companyName: string,
  website?: string | null,
): Promise<string> {
  const parts: string[] = [
    '<p class="account-intel-source-note">Limited mode — deploy <code>account-intel</code> Edge Function and set <code>GEMINI_API_KEY</code> for full search.</p>',
  ];

  if (website?.trim()) {
    const url = website.trim().startsWith('http') ? website.trim() : `https://${website.trim()}`;
    parts.push('<h3>Official website</h3>');
    parts.push(
      `<p class="account-intel-hit">Open the company site for the latest public information:<br><a href="${escapeHtml(url)}" target="_blank" rel="noreferrer">${escapeHtml(url)}</a></p>`,
    );
    const host = websiteHost(website);
    if (host) {
      parts.push(
        `<p class="account-intel-hit"><a href="https://www.google.com/search?q=${encodeURIComponent(`${companyName} site:${host}`)}" target="_blank" rel="noreferrer">Google: ${escapeHtml(companyName)} on ${escapeHtml(host)}</a></p>`,
      );
    }
  }

  parts.push(
    `<p class="account-intel-hit"><a href="https://www.google.com/search?q=${encodeURIComponent(`${companyName} Singapore company`)}&tbm=nws" target="_blank" rel="noreferrer">Google News: ${escapeHtml(companyName)}</a></p>`,
  );

  return parts.join('\n');
}
